// extracted by mini-css-extract-plugin
module.exports = {"details":"_2BExg","actions":"_1KTGh","actionButton":"_3xO_Y","mobile":"XEA8U","leftActions":"_2ACo4","location":"Q2d64","infoText":"_JzdZ"};